import { useCallback } from "react";
import { useGetTranslationsQuery } from "../../app/rootReducer";
import { TranslationsInterface } from "../interfaces/shared/TranslationsInterface";
import { StringTranslation } from "../utils/StringTranslation";

export type TranslateFn = (key: string) => string;

interface UseStringTranslationResult {
    t: TranslateFn;
    translations: TranslationsInterface | undefined;
    isLoading: boolean;
    isFetching: boolean;
}

export const useStringTranslation = (): UseStringTranslationResult => {
    const {
        data: translations,
        isLoading,
        isFetching,
    } = useGetTranslationsQuery();

    const t = useCallback<TranslateFn>(
        (key) => StringTranslation(key, translations),
        [translations],
    );

    return {
        t,
        translations,
        isLoading,
        isFetching,
    };
};
